/**
 * Logout — emergency, address-bar-reachable sign-out for the federated
 * ERIO ⇄ Ekselens SSO (ekselens.com docs §13). Works in any state:
 * clears the local shared-presence cookies, then redirects to ERIO's
 * RP-initiated Auth0 logout, which clears the `.ekselens.com` cookies on
 * both subdomains, ends the IdP session, and bounces back to the marketing
 * home with ?signed_out=1. If Auth0/OIDC is down, ERIO's endpoint still
 * redirects to return_to, so the user always lands somewhere sane.
 */
import { useEffect } from "react";
import { clearSsoCookies, ssoLogoutUrl } from "../lib/ssoSession";

export default function Logout() {
  useEffect(() => {
    clearSsoCookies();
    window.location.replace(ssoLogoutUrl());
  }, []);

  return (
    <div className="min-h-[60vh] flex items-center justify-center bg-black text-white" data-testid="logout-page">
      <p className="text-white/70 text-[15px]">Signing you out&hellip;</p>
    </div>
  );
}
